var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang
    ? _c("div", { staticClass: "estate-card-user-buttons" }, [
        _vm.showHide
          ? _c("img", {
              attrs: {
                src:
                  "/img/icons/hidden" +
                  (this.is_hidden ? "-active" : "") +
                  ".svg",
                alt: _vm.trans("labels.hide"),
                width: "24",
                height: "20"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onHideClick.apply(null, arguments)
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showSave
          ? _c("img", {
              attrs: {
                src:
                  "/img/icons/" +
                  _vm.network +
                  "/favorite" +
                  (this.is_saved ? "-active" : "") +
                  ".svg",
                alt: _vm.trans("labels.save"),
                width: "24",
                height: "20"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onSaveClick.apply(null, arguments)
                }
              }
            })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }